// export const API_URL = "https://psg.mindmadetech.in/admin/api";
export const API_URL ="https://psgiap.ac.in/admin/api";

// export const sitekey = "6Ldku8EqAAAAAIAH028jwrbEgDghrFS4Fr45X9FH";
// export const sitekey = "6LcbldorAAAAAGK_qbjG_rpzhFsGtddarccxiHMU"; //client account
// export const sitekey = "6LeoIeArAAAAAIqeIDOpk40Na2ZDT_6PaTE7Plrn"; //client account
export const sitekey = "6LcOMuArAAAAAFB5n_lHAQqjfn32wyW_qeYrfOD2"; //kaviya account
